export const RoleName = {
  REALTOR: 'internal.realtor',
  BORROWER: 'internal.borrower',
  EMPLOYEE: 'internal.employee',
};

export const INTERNAL_ROLE_NAME_PREFIX = 'internal.';

export const LOAN_OFFICER_ROLE_NORMALIZED_NAME = 'LOANOFFICER';
export const LOAN_OFFICER_MANAGER_ROLE_NORMALIZED_NAME = 'LOANOFFICERMANAGER';
